<template>
  <div class="nav-bar">
    <div class="left">
      <van-icon v-if="showBack" class="icon" name="arrow-left" size="20" @click="goBack"/>
      <div v-if="$slots['left-title']" class="left-title">
        <slot name="left-title"></slot>
      </div>
      <div v-if="title && showRole" class="center-title t-center" v-html="title">
      </div>
    </div>
    <div v-if="title && !showRole" class="center-title t-center" v-html="title">
      </div>
    <div class="right">
      <van-dropdown-menu v-if="showRole">
        <van-dropdown-item
          ref="roleItem"
          :title="currentRoleName"
          :disabled="isAutoLogin"
        >
          <template v-for="item in calRoleList">
            <div @click="changeRole(item.value)" :class="['role', defaultRoleInfo.id === item.value ?'active':'']" :key="item.value" v-if="item.value !== 'add'">
              {{item.text}}
            </div>
            <div @click="changeRole(item.value)" class="add" :key="item.value" v-else>
              <van-icon name="add-o" /><span>
                {{ $t('changeRole.添加角色') }}
              </span>
            </div>
          </template>
        </van-dropdown-item>
      </van-dropdown-menu>
      <!-- <slot name="right"></slot> -->
    </div>
  </div>
</template>

<script>
  import {changeRole} from '@/views/mixins';
  export default {
    mixins: [changeRole],
    props: {
      showBack: {
        type: Boolean,
        default: true
      },
      title: {
        type: String,
        default: ''
      },
      goBack: {
        type: Function,
        default: () => {console.log('back');}
      },
      showRole: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isAutoLogin: !!sessionStorage.getItem('isAutoLogin')
      };
    },
    mounted() {
    },
    methods: {
      changeRole(val) {
        this.handleChangeRole(val, () => {
          this.$emit('change');
          this.$refs.roleItem.toggle();
        });
      }
    }
  };
</script>

<style lang="less" scoped>
.nav-bar {
  position: relative;
  width: calc(100% - 20px);
  z-index: 999;
  top: 0;
  height: 44px;
  line-height: 44px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(0,0,0,.75);
  background: @red;
  color: #fff;
  .center-title{
    width: 100%;
    height: 44px;
    line-height: 47px;
    font-size: 14px;
  }
  .left-title{
    font-size: 14px;
  }
  .left,.right {
    // width: 50px;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .left {
    height: 100%;
    position: absolute;
    left: 10px;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    .icon {
      width: 30px;
      height: 100%;
      line-height: 50px;
    }
  }
  .right {
    position: absolute;
    right: 10px;
    top: 0;
    height: 100%;
    z-index: 10;
    /deep/ .van-dropdown-menu {
      background: transparent;
      .van-dropdown-menu__bar{
        height: 44px;
      }
      .van-overlay {
        z-index: 110;
        // overflow: visible;
        &::before {
          position: absolute;
          z-index: 2020;
          content: '';
          top: -1px;
          right: 40px;
          display: block;
          border: 3px solid;
          border-color: transparent transparent  #fff   transparent;
        }
      }
      .van-dropdown-menu__bar {
        box-shadow: none;
      }
      .van-dropdown-menu__title {
        color: #fff;
        &::after {
          border-color: transparent transparent #fff #fff;
        }
      }
      .van-popup--top {
        top: 5px;
        right: 0 !important;
        left: calc(100% - 230px);
        width: 214px;
        border-radius: 10px;
      }
    }
  }
}
.role {
  font-size: 13px;
  height: 18px;
  line-height: 18px;
  color: #393D40;
  padding: 8px 15px;
  border-bottom: 1px solid #F1F1F1;
  &.active {
    color: #E64B5C;
  }
}
.add {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  background: #FFE0E5;
  color: #E64B5C;
  border-radius: 0 0 10px 10px;
  span {
    margin-left: 5px;
  }
}
</style>
